import React, { useCallback } from "react";
import { Dialog, Pane, Text, toaster } from "evergreen-ui";
import useControlHub from "../hooks/useControlHub";

const VendorDeleteDialog = ({ onClose, onFailure, onSuccess, vendor }) => {
  const { api } = useControlHub();

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  const handleConfirm = useCallback(() => {
    api
      .replaceVendor({
        vendorID: vendor["id"],
        vendorData: { user_active: false },
      })
      .then((data) => {
        if (!data.success) {
          throw new Error(
            `Something went wrong while deleting vendor: ${data.message || "-"}`
          );
        }
        toaster.success("Vendor has been deleted");
        onSuccess();
      })
      .catch((error) => {
        toaster.danger(error?.message || "Unable to delete vendor");
        onFailure(error);
      });
  }, [api, onFailure, onSuccess, vendor]);

  return (
    <Dialog
      isShown={true}
      onCloseComplete={handleClose}
      onConfirm={handleConfirm}
      title="Delete Vendor"
    >
      <Pane display="flex" justifyContent="center" marginY={32}>
        <Text>{`Delete ${vendor["name"]}?`}</Text>
      </Pane>
    </Dialog>
  );
};

export default VendorDeleteDialog;
